module.exports = __webpack_public_path__ + "img/logo_lama_big.png";